import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

import { getFieldError } from "../utils";

import type { FieldComponent } from "../types";

const AutocompleteComponent: FieldComponent<never> = ({ field, methods }) => {
  const {
    formState: { errors },
  } = methods;
  const options = field.options ?? [];
  const errorMessage = errors[field.name]?.message;
  const error = getFieldError(errorMessage);
  const customOnChange =
    field.type === "autocomplete" ? field.onChange : undefined;

  return (
    <Controller
      name={field.name}
      control={methods.control}
      defaultValue={field.defaultValue ?? null}
      render={({ field: controllerField }) => {
        const value =
          controllerField.value != null
            ? (field.options?.find(
                (option) => option.value === controllerField.value,
              ) ?? null)
            : null;

        return (
          <Autocomplete
            disablePortal
            options={options}
            value={value}
            disabled={field.disabled}
            loading={field.loading}
            onChange={(event, option) => {
              const newValue = option?.value ?? null;
              controllerField.onChange(newValue);
              if (customOnChange) {
                customOnChange(event, newValue);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required={field?.required}
                label={field.label}
                fullWidth
                error={Boolean(error)}
                helperText={error}
                className={field.className}
                style={field.style}
                sx={field.sx}
                inputRef={controllerField.ref}
              />
            )}
          />
        );
      }}
    />
  );
};

export { AutocompleteComponent };
